// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { Scope } from '@unform/core';
// import * as Yup from 'yup';
// import { toast } from 'react-toastify';

// import api from '../../../../services/api';
// import history from '../../../../services/history';

// import { AppError } from '../../../../errors/AppError';

// import {
//   opTipoAcesso,
//   opTipoDocumento,
//   opMascaraDocumento,
// } from '../../../../lib/const';
// import {
//   opAdministrador,
//   opEmpresaAdministrador,
//   opDocumento,
// } from '../../../../lib/inputOption';
// import { YupValidaDocumento, splitArray } from '../../../../lib/inputUtils';

// import { permiteEmpEmailUsuarioReponsavel } from '../../../../lib/paramUtils';

// import TitleBar from '../../../../components/TitleBar';
// import { FormWrapper, Form } from '../../../../components/Form';
// import Input from '../../../../components/Form/Input';
// import Select from '../../../../components/Form/Input/Select';
// import Checkbox from '../../../../components/Form/Input/Checkbox';
// import MaskedInput from '../../../../components/Form/Input/MaskedInput';

// const schema = Yup.object().shape({
//   login: Yup.string()
//     .trim()
//     .matches(/^\S*$/, 'O campo "Login" não aceita espaços')
//     .min(3, 'O campo "Login" precisa ter no mínimo 3 caracteres')
//     .required('O campo "Login" é obrigatório'),
//   nome: Yup.string()
//     .min(3, 'O campo "nome" precisa ter no mínimo 3 caracteres')
//     .required('O campo "Nome" é obrigatório'),
//   email: Yup.string()
//     .email('E-mail inválido')
//     .required('O campo "E-mail" é obrigatório'),
//   emailResponsavel: Yup.string()
//     .when('$paramField1', (paramField1, schema1) =>
//       paramField1
//         ? schema1.required('O campo "E-mail Responsável" é obrigatório')
//         : schema1
//     )
//     .email('E-mail responsável é inválido'),
//   senha: Yup.string()
//     .min(6, 'O campo "Senha" precisa ter no mínimo 6 caracteres')
//     .required('O campo "Senha" é obrigatório'),
//   adm: Yup.number()
//     .typeError('O campo "Administrador" deve ser preenchido')
//     .required('O campo "Administrador" é obrigatório'),
//   utilizaMobile: Yup.string().oneOf(['0', '1']),
//   tipoDocumento: Yup.number()
//     .typeError('O campo "Documento" deve ser preenchido')
//     .required('O campo "Documento" é obrigatório'),
//   documento: Yup.string()
//     .required('O campo "Número Documento" é obrigatório')
//     .test('documento', 'O documento é inválido', function isValid(value) {
//       return YupValidaDocumento(value, this);
//     }),
// });

// function EmpresaUsuarioCriar() {
//   const formRef = useRef(null);

//   const location = useLocation();
//   const { idEmpresa } = location.state;

//   const { adm: tipoAcesso } = useSelector((state) => state.user.profile || {});

//   const [usuarioComplemento, setUsuarioComplemento] = useState([]);
//   const [tipoDocumento, setTipoDocumento] = useState(opTipoDocumento.CPF);

//   const [nivelUsuario, setNivelUsuario] = useState(opAdministrador[0]);

//   useEffect(() => {
//     /** dados complementares conforme empresa do novo usuário */
//     api.get(`empresa/${idEmpresa}/complemento`).then((response) => {
//       const { tipoComplemento } = response.data;
//       setUsuarioComplemento(tipoComplemento);
//     });
//   }, [idEmpresa]);

//   const handleConfirmar = useCallback(
//     async (data) => {
//       try {
//         await schema.validate(data, {
//           context: {
//             paramField1: permiteEmpEmailUsuarioReponsavel(),
//           },
//           abortEarly: false,
//         });

//         const {
//           login,
//           senha,
//           nome,
//           email,
//           emailResponsavel,
//           adm,
//           utilizaMobile,
//           tipoDocumento: tipoDoc,
//           documento,
//           complemento,
//         } = data;

//         const fmtComplemento = complemento
//           ? Object.entries(complemento).map((arr) => {
//               const [chave, valor] = arr;
//               return { chave, valor };
//             })
//           : null;

//         await api.post(`empresa/${idEmpresa}/usuario`, {
//           login,
//           senha,
//           nome,
//           email,
//           emailResponsavel,
//           adm: String(adm),
//           utilizaMobile: String(utilizaMobile),
//           tipoDocumento: String(tipoDoc),
//           documento,
//           complemento: fmtComplemento,
//         });

//         toast.success('Usuário cadastrado com sucesso!');

//         history.goBack();
//       } catch (err) {
//         AppError(err, formRef);
//       }
//     },
//     [idEmpresa]
//   );

//   const handleTipoDocumento = useCallback((value) => {
//     setTipoDocumento(value);
//   }, []);

//   const handleNivelUsuario = useCallback((usuarioSelecionado) => {
//     setNivelUsuario(usuarioSelecionado);
//   }, []);

//   return (
//     <>
//       <TitleBar back={!!location.background} title="Novo Usuário" />
//       <FormWrapper>
//         <Form
//           id="formUsuario"
//           ref={formRef}
//           onSubmit={handleConfirmar}
//           autoComplete="off"
//         >
//           <Form.Column>
//             <Form.Row>
//               <Input id="login" name="login" label="Login" type="text" />
//               <Input id="nome" name="nome" label="Nome" type="text" />
//             </Form.Row>
//             <Form.Row>
//               <Input id="senha" name="senha" label="Senha" type="password" />
//               <Input id="email" name="email" label="E-mail" type="text" />
//             </Form.Row>
//             <Form.Row>
//               {tipoAcesso === opTipoAcesso.ADMIN_PLATAFORMA && (
//                 <Select
//                   id="adm"
//                   name="adm"
//                   label="Administrador"
//                   isSearchable={false}
//                   defaultValue={opAdministrador[0]}
//                   options={opAdministrador}
//                   onChange={(usuarioSelecionado) =>
//                     handleNivelUsuario(usuarioSelecionado)
//                   }
//                 />
//               )}
//               {tipoAcesso === opTipoAcesso.ADMIN_EMPRESA && (
//                 <Select
//                   id="adm"
//                   name="adm"
//                   label="Administrador"
//                   isSearchable={false}
//                   defaultValue={opEmpresaAdministrador[0]}
//                   options={opEmpresaAdministrador}
//                 />
//               )}
//               <Select
//                 id="tipoDocumento"
//                 name="tipoDocumento"
//                 label="Documento"
//                 defaultValue={opDocumento[opTipoDocumento.CPF]}
//                 options={opDocumento}
//                 isSearchable={false}
//                 onChange={({ value }) => {
//                   handleTipoDocumento(value);
//                 }}
//                 width={400}
//               />
//               <MaskedInput
//                 id="documento"
//                 name="documento"
//                 label="Número Documento"
//                 mask={opMascaraDocumento[tipoDocumento] || ''}
//               />
//             </Form.Row>
//             <Form.Row>
//               {permiteEmpEmailUsuarioReponsavel() && (
//                 <Input
//                   id="emailResponsavel"
//                   name="emailResponsavel"
//                   label="E-mail Responsável"
//                   type="text"
//                 />
//               )}
//             </Form.Row>
//             <Form.Row>
//               <Checkbox
//                 id="utilizaMobile"
//                 name="utilizaMobile"
//                 label="Utiliza Mobile?"
//               />
//             </Form.Row>
//             <Form.Column>
//               <h3>Informações complementares</h3>
//               {usuarioComplemento && usuarioComplemento.length ? (
//                 <Scope path="complemento">
//                   {splitArray(usuarioComplemento, 2).map((arr, idx1) => (
//                     // divide array em subarrays de duas posições [[1,2],[3,4]]
//                     <Form.Row key={idx1}>
//                       {arr.map((cp, idx2) =>
//                         nivelUsuario.value === opTipoAcesso.CLIENTE &&
//                         cp.descricao === 'WhatsApp' ? null : (
//                           <MaskedInput
//                             key={idx2}
//                             id={cp.chave}
//                             name={cp.chave}
//                             label={cp.descricao}
//                             mask={cp.mascara}
//                           />
//                         )
//                       )}
//                     </Form.Row>
//                   ))}
//                 </Scope>
//               ) : (
//                 <Form.NotFound>Nenhum item encontrado</Form.NotFound>
//               )}
//             </Form.Column>
//           </Form.Column>
//           <Form.Separate withFlex />
//           <Form.Footer>
//             <button
//               id="btn-cancel"
//               type="button"
//               onClick={() => history.goBack()}
//             >
//               Cancelar
//             </button>
//             <button id="btn-submit" type="submit" form="formUsuario">
//               Confirmar
//             </button>
//           </Form.Footer>
//         </Form>
//       </FormWrapper>
//     </>
//   );
// }

// export { EmpresaUsuarioCriar };

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Scope } from '@unform/core';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import api from '../../../../services/api';
import history from '../../../../services/history';

import { AppError } from '../../../../errors/AppError';

import {
  opTipoAcesso,
  opTipoDocumento,
  opMascaraDocumento,
} from '../../../../lib/const';
import {
  opAdministrador,
  opEmpresaAdministrador,
  opDocumento,
  opCatalogoSituacao,
} from '../../../../lib/inputOption';
import { YupValidaDocumento, splitArray } from '../../../../lib/inputUtils';

import {
  permiteEmpEmailUsuarioReponsavel,
  vinculaCatalogoUsuario,
} from '../../../../lib/paramUtils';

import TitleBar from '../../../../components/TitleBar';
import { FormWrapper, Form } from '../../../../components/Form';
import Input from '../../../../components/Form/Input';
import Select from '../../../../components/Form/Input/Select';
import Checkbox from '../../../../components/Form/Input/Checkbox';
import MaskedInput from '../../../../components/Form/Input/MaskedInput';
import { RowMaster, Table } from '../../../../components/Table';
import TableHeader from '../../../../components/Table/TableHeader';
import Pagination from '../../../../components/EditorAI/Pagination';

const schema = Yup.object().shape({
  login: Yup.string()
    .trim()
    .matches(/^\S*$/, 'O campo "Login" não aceita espaços')
    .min(3, 'O campo "Login" precisa ter no mínimo 3 caracteres')
    .required('O campo "Login" é obrigatório'),
  nome: Yup.string()
    .min(3, 'O campo "nome" precisa ter no mínimo 3 caracteres')
    .required('O campo "Nome" é obrigatório'),
  email: Yup.string()
    .email('E-mail inválido')
    .required('O campo "E-mail" é obrigatório'),
  emailResponsavel: Yup.string()
    .when('$paramField1', (paramField1, schema1) =>
      paramField1
        ? schema1.required('O campo "E-mail Responsável" é obrigatório')
        : schema1
    )
    .email('E-mail responsável é inválido'),
  senha: Yup.string()
    .min(6, 'O campo "Senha" precisa ter no mínimo 6 caracteres')
    .required('O campo "Senha" é obrigatório'),
  adm: Yup.number()
    .typeError('O campo "Administrador" deve ser preenchido')
    .required('O campo "Administrador" é obrigatório'),
  utilizaMobile: Yup.string().oneOf(['0', '1']),
  tipoDocumento: Yup.number()
    .typeError('O campo "Documento" deve ser preenchido')
    .required('O campo "Documento" é obrigatório'),
  documento: Yup.string()
    .required('O campo "Número Documento" é obrigatório')
    .test('documento', 'O documento é inválido', function isValid(value) {
      return YupValidaDocumento(value, this);
    }),
});

function EmpresaUsuarioCriar() {
  const formRef = useRef(null);
  const paginationRef = useRef(null);

  const location = useLocation();
  const { idEmpresa } = location.state;

  const { adm: tipoAcesso } = useSelector((state) => state.user.profile || {});

  const [usuarioComplemento, setUsuarioComplemento] = useState([]);
  const [tipoDocumento, setTipoDocumento] = useState(opTipoDocumento.CPF);
  const [nivelUsuario, setNivelUsuario] = useState(opAdministrador[0]);

  /** catálogo por empresa */
  const [empresaCatalogo, setEmpresaCatalogo] = useState([]);
  const [catalogosSelecionados, setCatalogosSelecionados] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  const carregaEmpresaCatalogo = useCallback(async () => {
    if (!vinculaCatalogoUsuario()) return;

    try {
      const response = await api.get(`/empresa/${idEmpresa}/catalogo`, {
        params: {
          page: currentPage,
        },
      });

      const catalogos = response.data.catalogo
        .map(({ arquivo, empresas, ...catalogo }) => {
          const { modelos, fabricante } = arquivo;

          return {
            ...catalogo,
            fabricante: fabricante.descricao,
            modelo: modelos.map((m) => m.descricao).join(', '),
            relacionadoEmpresa:
              empresas.filter((e) => e.idEmpresa === idEmpresa).length > 0,
          };
        })
        .filter((catalogo) => catalogo.relacionadoEmpresa);

      setEmpresaCatalogo(catalogos);
      setTotalPage(response.data.total || 0);

      if (
        response.data.total > 0 &&
        currentPage > response.data.total &&
        paginationRef.current
      ) {
        paginationRef.current.setPage(1);
        setCurrentPage(1);
      }
    } catch (err) {
      AppError(err);
    }
  }, [idEmpresa, currentPage]);

  useEffect(() => {
    api.get(`empresa/${idEmpresa}/complemento`).then((response) => {
      const { tipoComplemento } = response.data;
      setUsuarioComplemento(tipoComplemento);
    });
  }, [idEmpresa]);

  useEffect(() => {
    carregaEmpresaCatalogo();
  }, [carregaEmpresaCatalogo]);

  const handleToggleCatalogo = useCallback((idCatalogo) => {
    setCatalogosSelecionados((oldState) => {
      if (oldState.includes(idCatalogo)) {
        return oldState.filter((id) => id !== idCatalogo);
      }

      return [...oldState, idCatalogo];
    });
  }, []);

  const handleConfirmar = useCallback(
    async (data) => {
      try {
        await schema.validate(data, {
          context: {
            paramField1: permiteEmpEmailUsuarioReponsavel(),
          },
          abortEarly: false,
        });

        const {
          login,
          senha,
          nome,
          email,
          emailResponsavel,
          adm,
          utilizaMobile,
          tipoDocumento: tipoDoc,
          documento,
          complemento,
        } = data;

        const fmtComplemento = complemento
          ? Object.entries(complemento).map((arr) => {
              const [chave, valor] = arr;
              return { chave, valor };
            })
          : null;

        const response = await api.post(`empresa/${idEmpresa}/usuario`, {
          login,
          senha,
          nome,
          email,
          emailResponsavel,
          adm: String(adm),
          utilizaMobile: String(utilizaMobile),
          tipoDocumento: String(tipoDoc),
          documento,
          complemento: fmtComplemento,
        });

        /**
         * Ajuste conforme o retorno real do backend.
         * Ex.: response.data.idUsuario ou response.data.id
         */
        const idUsuarioCriado =
          response?.data?.idUsuario || response?.data?.id || null;

        /**
         * Chama endpoint específico para vincular os catálogos ao usuário.
         * Ajuste a URL e o payload conforme o contrato real da sua API.
         */
        if (
          vinculaCatalogoUsuario() &&
          catalogosSelecionados.length > 0 &&
          idUsuarioCriado
        ) {
          await api.post(
            `/empresa/${idEmpresa}/usuario/${idUsuarioCriado}/catalogo`,
            {
              catalogos: catalogosSelecionados,
            }
          );
        }

        toast.success('Usuário cadastrado com sucesso!');
        history.goBack();
      } catch (err) {
        AppError(err, formRef);
      }
    },
    [idEmpresa, catalogosSelecionados]
  );

  const handleTipoDocumento = useCallback((value) => {
    setTipoDocumento(value);
  }, []);

  const handleNivelUsuario = useCallback((usuarioSelecionado) => {
    setNivelUsuario(usuarioSelecionado);
  }, []);

  return (
    <>
      <TitleBar back={!!location.background} title="Novo Usuário" />
      <FormWrapper>
        <Form
          id="formUsuario"
          ref={formRef}
          onSubmit={handleConfirmar}
          autoComplete="off"
        >
          <Form.Column>
            <Form.Row>
              <Input id="login" name="login" label="Login" type="text" />
              <Input id="nome" name="nome" label="Nome" type="text" />
            </Form.Row>

            <Form.Row>
              <Input id="senha" name="senha" label="Senha" type="password" />
              <Input id="email" name="email" label="E-mail" type="text" />
            </Form.Row>

            <Form.Row>
              {tipoAcesso === opTipoAcesso.ADMIN_PLATAFORMA && (
                <Select
                  id="adm"
                  name="adm"
                  label="Administrador"
                  isSearchable={false}
                  defaultValue={opAdministrador[0]}
                  options={opAdministrador}
                  onChange={(usuarioSelecionado) =>
                    handleNivelUsuario(usuarioSelecionado)
                  }
                />
              )}

              {tipoAcesso === opTipoAcesso.ADMIN_EMPRESA && (
                <Select
                  id="adm"
                  name="adm"
                  label="Administrador"
                  isSearchable={false}
                  defaultValue={opEmpresaAdministrador[0]}
                  options={opEmpresaAdministrador}
                />
              )}

              <Select
                id="tipoDocumento"
                name="tipoDocumento"
                label="Documento"
                defaultValue={opDocumento[opTipoDocumento.CPF]}
                options={opDocumento}
                isSearchable={false}
                onChange={({ value }) => {
                  handleTipoDocumento(value);
                }}
                width={400}
              />

              <MaskedInput
                id="documento"
                name="documento"
                label="Número Documento"
                mask={opMascaraDocumento[tipoDocumento] || ''}
              />
            </Form.Row>

            <Form.Row>
              {permiteEmpEmailUsuarioReponsavel() && (
                <Input
                  id="emailResponsavel"
                  name="emailResponsavel"
                  label="E-mail Responsável"
                  type="text"
                />
              )}
            </Form.Row>

            <Form.Row>
              <Checkbox
                id="utilizaMobile"
                name="utilizaMobile"
                label="Utiliza Mobile?"
              />
            </Form.Row>

            <Form.Column>
              <h3>Informações complementares</h3>
              {usuarioComplemento && usuarioComplemento.length ? (
                <Scope path="complemento">
                  {splitArray(usuarioComplemento, 2).map((arr, idx1) => (
                    <Form.Row key={idx1}>
                      {arr.map((cp, idx2) =>
                        nivelUsuario.value === opTipoAcesso.CLIENTE &&
                        cp.descricao === 'WhatsApp' ? null : (
                          <MaskedInput
                            key={idx2}
                            id={cp.chave}
                            name={cp.chave}
                            label={cp.descricao}
                            mask={cp.mascara}
                          />
                        )
                      )}
                    </Form.Row>
                  ))}
                </Scope>
              ) : (
                <Form.NotFound>Nenhum item encontrado</Form.NotFound>
              )}
            </Form.Column>

            {/* {vinculaCatalogoUsuario() && (
              <Form.Column>
                <h3>Catálogos da empresa</h3>
                <p>Selecione os catálogos que ficarão vinculados ao usuário.</p>

                <Table>
                  <TableHeader
                    withPadding
                    cbSort={() => {}}
                    titles={[
                      { fieldname: 'selecionado', title: 'Vincular' },
                      { fieldname: 'nome', title: 'Classe Operacional' },
                      { fieldname: 'modelo', title: 'Modelo' },
                      { fieldname: 'fabricante', title: 'Fabricante' },
                      { fieldname: 'versao', title: 'Versão' },
                      { fieldname: 'situacao', title: 'Situação' },
                    ]}
                  />
                  <tbody>
                    {empresaCatalogo.length > 0 ? (
                      empresaCatalogo.map((catalogo) => (
                        <RowMaster key={catalogo.idCatalogo}>
                          <td>
                            <input
                              type="checkbox"
                              checked={catalogosSelecionados.includes(
                                catalogo.idCatalogo
                              )}
                              onChange={() =>
                                handleToggleCatalogo(catalogo.idCatalogo)
                              }
                            />
                          </td>
                          <td>{catalogo.nome}</td>
                          <td>{catalogo.modelo}</td>
                          <td>{catalogo.fabricante}</td>
                          <td>{catalogo.versao}</td>
                          <td>
                            {opCatalogoSituacao[catalogo.situacao]
                              ? opCatalogoSituacao[catalogo.situacao].label
                              : ''}
                          </td>
                        </RowMaster>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6}>Nenhum catálogo encontrado</td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <div style={{ marginTop: 12 }}>
                  Selecionados: {catalogosSelecionados.length}
                </div>

                <Pagination
                  ref={paginationRef}
                  pageCount={totalPage}
                  initialData={currentPage}
                  onPageChange={(page) => {
                    setCurrentPage(Number(page));
                  }}
                />
              </Form.Column>
            )} */}
          </Form.Column>

          <Form.Separate withFlex />

          <Form.Footer>
            <button
              id="btn-cancel"
              type="button"
              onClick={() => history.goBack()}
            >
              Cancelar
            </button>
            <button id="btn-submit" type="submit" form="formUsuario">
              Confirmar
            </button>
          </Form.Footer>
        </Form>
      </FormWrapper>
    </>
  );
}

export { EmpresaUsuarioCriar };
